
























import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import type { ProductVariantExtended } from '~/types/product/ProductVariantExtended';
import ComparisonTable from '~/components/molecules/Product/ComparisonProducts/ComparisonTable/ComparisonTable.vue';
import { getAttributesToCompare } from '~/helpers/product/getAttributesToCompare';
import type { ComparisonProductData, AttributesArray } from '~/types/product/ComparisonProducts';
import { DEFAULT_ATTRIBUTE_LIMIT } from '~/constants/comparisonProducts';
import type { ProductProcessedAttributes } from '~/types/product/attribute/ProductProcessedAttributes';

export default defineComponent({
  name: 'ComparisonProducts',
  components: {
    ComparisonTable,
  },
  props: {
    currentProduct: {
      type: Object as PropType<ProductVariantExtended>,
      required: true,
    },
    currentAttributesLocalized: {
      type: Object as PropType<ProductProcessedAttributes>,
      required: true,
    },
    comparisonProductsData: {
      type: Array as PropType<ComparisonProductData[]>,
      required: true,
    },
  },
  setup(props) {
    const showMore = ref(false);

    const currentSku = computed<string>(() => {
      return props.currentProduct.sku;
    });

    const productsDataToCompare = computed<ComparisonProductData[]>(() => {
      const currentProductData: ComparisonProductData = {
        product: props.currentProduct,
        attributesLocalized: props.currentAttributesLocalized,
      };
      return [currentProductData, ...props.comparisonProductsData];
    });

    const attributesToCompare = computed<AttributesArray>(() => getAttributesToCompare(productsDataToCompare.value));

    const showExpandButton = computed<boolean>(() => {
      return attributesToCompare.value.length > (DEFAULT_ATTRIBUTE_LIMIT);
    });

    const onClick = () => {
      showMore.value = !showMore.value;
    };

    return {
      productsDataToCompare,
      attributesToCompare,
      showMore,
      currentSku,
      showExpandButton,
      onClick,
    };
  },
});

